import { AssetSvgProps } from "../../../shared/assets"

export const defaultColors = {
    "col1n": "#000000"
}

function LegSki001({ colors = defaultColors, className, onClick, outerTransform, transform, startDrag }: AssetSvgProps) {
    return (
        <g transform={outerTransform}><g className={className} onClick={onClick} transform={transform} onMouseDown={startDrag} onTouchStart={startDrag}><defs>
                <path
                    fill={colors.col1n}
                    d="M125.75.15h-.05V.2q-.2.05-.35.1Q62.1 12.55.85.4.6.3.35.3.2.25.1.25V.2H0v10.6h125.75V.15z"
                    id="LegSki001__Symbol_3_0_Layer0_0_FILL"
                />
            </defs>
            <g id="LegSki001__col1n" transform="translate(129.65 310.2)">
                <use
                    xlinkHref="#LegSki001__Symbol_3_0_Layer0_0_FILL"
                    transform="translate(0 -.15)"
                    id="LegSki001__col1n_FL"
                />
            </g>
        </g></g>
    )
}

export default LegSki001
